import { Controller } from "stimulus"
import Cookies from 'js-cookie'

export default class extends Controller {
  static targets = ['element', 'showIcon', 'hideIcon']

  connect(){
    this.isContentHidden = false
    if (this.data.get("initialHide") && Cookies.get(this.data.get("cookieName"))){
      this.initialHide()
    }
  }

  hide() {
    if (this.hasShowIconTarget && this.hasHideIconTarget) {
      this.showIconTarget.classList.toggle(this.className)
      this.hideIconTarget.classList.toggle(this.className)
    }

    this.elementTargets.forEach((e) => {
      e.classList.toggle(this.className)
    })
    if (this.data.has('toggleCookie') && Cookies.get(this.data.get('cookieName'))) {
      Cookies.remove(this.data.get('cookieName'))
    } else {
      this.createCookie(this.data.get('cookieName'))
    }
  }

  initialHide(){
    if (this.hasShowIconTarget && this.hasHideIconTarget) {
      this.showIconTarget.classList.toggle(this.className)
      this.hideIconTarget.classList.toggle(this.className)
    }

    this.elementTargets.forEach((e) => {
      e.classList.toggle(this.className)
    })

  }

  createCookie(name) {
    Cookies.set(name, 1)
  }

  get className(){
    if (this.data.get("className")) {
      return this.data.get("className");
    }

    return "hide"
  }
}
